import { AccountType } from './app/shared/consts/accountType';
import { AccountPermission } from './app/shared/consts/accountPermission';
import { MailFrequency } from './app/notifications-new/models/mail-frequency';

// const colors = {
//   reed: 'dc3545',
// };

export const configACADEMONDO = {
  academondo: 'Academondo',
  academondoDash: 'Academondo',
  academondoCom: 'ai.academondo.com',
  academondoUrl: 'https://ai.academondo.com',
  supportMail: 'support@academondo.com',
  reviewMail: 'support@academondo.com',
  senderMail: 'support@academondo.com',
  // superAdmin: 'agerskov@academondo.com',
  // groupSuperAdmins: [
  //   'agerskov@academondo.com',
  //   'ellaagerskov@gmail.com',
  //   'snagerskov@gmail.com',
  // ],
  // welcomeScientistTemplateId: 'd-27d49f65c4fc4276a990c31f68d34b39',
  // welcomeCompanyTemplateId: 'd-0a77c5f347fb4cbf99486789fb7b5814',
  // inviteTemplateId: 'd-f70e8eee6c9c4b72a8a1ee84f9e5415d', // sendgrid
  welcomeScientistTemplateId: 2,
  welcomeCompanyTemplateId: 3,
  inviteTemplateId: 4,
  notificationTemplateId: 8,

  // autoJoinNetworks: ['-NlQ-z3kt-IG7sbPrhZm', '-OICRTyAG9fH_1h9CGCU'],

  // defaultNotificationFreq: MailFrequency.Weekly,
  // defaultNotificationFreqForCompanies: MailFrequency.Monthly,

  dateFormat: 'da-DK',
  languageCKEditor: 'en-US',

  language: 'en',
  defaultUserCoverUrl:
    'https://strapi-prod.sos-ch-dk-2.exo.io/ebrains_ssd_call_ebrains_website_3a68136980.jpg',
  defaultEventCoverUrlCredit: '',
  defaultEventCoverUrl:
    'https://firebasestorage.googleapis.com/v0/b/academondo-demo.appspot.com/o/00000xxx%2Fevent-cover.jpg?alt=media&token=cbbfaadc-e88c-4e86-9a3e-47ef36c97fdd',
  defaultCommunityCoverUrlCredit: '',
  defaultCommunityCoverUrl:
    'https://firebasestorage.googleapis.com/v0/b/academondo-demo.appspot.com/o/00000xxx%2Fcommunity-cover.jpg?alt=media&token=9cff048f-c0ce-4363-97b7-61f43fa1051a',
  defaultIdeaCoverUrlCredit: '',
  defaultIdeaCoverUrl:
    'https://firebasestorage.googleapis.com/v0/b/academondo-demo.appspot.com/o/00000xxx%2Fidea-cover.png?alt=media&token=953c4f68-9802-4cf6-994f-94c3876edd9f',
  welcomeWidgetCoverUrlCredit: '',
  welcomeWidgetCoverUrl:
    'https://firebasestorage.googleapis.com/v0/b/neuroscienceacademydenmark.appspot.com/o/1111%2Fthumbnail_NADBackground.001.png?alt=media&token=7140b430-e829-480b-b5a0-52a50d616c5b',

  // only select one
  welcomeWidgetIcon: false,
  welcomeWidgetIconInv: false,
  welcomeWidgetLogo: false,
  welcomeWidgetLogoInv: true,

  // only select one
  EUWelcomeWidgetLogo: false,
  EUWelcomeWidgetIcon: false,

  // welcomeWidgetVideo:
  //   'https://dandybusinesspark.dk/wp-content/uploads/2023/11/Forside-film_Low.mp4',
  // welcomeWidgetVideoHeadline: 'Samarbejde, innovation og bæredygtig vækst.',
  // welcomeWidgetVideoPrimaryColorBackground: false,
  // welcomeWidgetVideo:
  //   'https://open-entrepreneurship.com/wp-content/uploads/2017/08/v2.mp4',
  // welcomeWidgetVideoHeadline:
  //   'Turning world class research into world class companies',
  // welcomeWidgetVideoPrimaryColorBackground: true,

  showWelcomeWidget: true,

  // disabledSignupEmail: 'office@neuroscienceacademydenmark.dk',
  // disabledSignupForm: 'https://eu.jotform.com/220815942508053',

  termsLink:
    'https://firebasestorage.googleapis.com/v0/b/academondo.appspot.com/o/terms.html?alt=media&token=0e2dfc8b-672d-49bd-835d-944162cebbe4',
  privacyPolicyLink:
    'https://firebasestorage.googleapis.com/v0/b/academondo.appspot.com/o/privacy-policy.html?alt=media&token=5de3bf51-f454-433e-9d9c-15de16838c3d',
  copyRightDate: '© 2018,',

  // combineTermsAndPolicy: false,

  academondoStreet: 'Holbergsvej 22,',
  academondoPostboxCity: '8800 Viborg',
  academondoCVR: '37919527',
  academondoPhone: '+45 21 42 64 44',

  twitterLink: 'https://twitter.com/academondo', // leave blank if it should not be shown
  facebookLink: 'https://www.facebook.com/AcadeMondo', // leave blank if it should not be shown
  linkedinLink: 'https://linkedin.com/company/academondo/', // leave blank if it should not be shown
  instagramLink: '', // https://www.instagram.com/companyName/ // leave blank if it should not be shown
  fbPagePluginLink: '',

  showTermsInNavbarMenu: true,

  showSiteTagsAsChips: true,
  showCvTagsAsChips: true,
  // setCompanyNameAsRequiredForCV: true,
  // showSitesAlphabetically: true,
  // showJobsAlphabetically: true,
  showMaxSearchResultSelector: false,
  // maxInfoOnSearchResults: true,
  // numberOfTagsOnSearchResults: 2,

  sortGroupsAlphabetically: false,

  showPostsInSearchWhenNotLoggedIn: true,
  maxDistanceInSearch: 350, // set to 0 tohide option to search by distance
  maxSearchResults: 50,
  defaultSearchType: 'All', // SearchableTypes.All
  showProfileWidgetStats: false,
  showSearchForXButtonInProfileWidget: false, // 'Job', // SearchableTypes.
  showSearchForXButtonInProfileWidgetText: 'Find Børsopslag',
  showCreateButtonCommunityInProfileWidget: false,
  showCreateButtonEventInProfileWidget: false,
  showCreateButtonIdeaInProfileWidget: false,
  showDateOnPostsInFeedWidget: true,
  showMemberCountOnEventWidget: true,

  // useEnterForSearch: false,
  autoSearchDelayForDebouncer: 500, // default is 1000

  aboutSpecial: '', // leave blank if it should not be shown
  aboutSpecialUrl:
    'https://serwiz.kanpla.dk/screen/02kVRBSUXGPF4j3CuqRU?disableCookie=1',
  aboutSpecialIcon: 'restaurant',

  urlForWordpressACFEvents: null, // 'https://dandybusinesspark.dk', // leave blank if it should not be shown
  externalLinkWordpressEvents: 'https://dandybusinesspark.dk/events/',
  TitleForWordpressevents: 'Events',
  eventParamForWordpressevents: 'event',
  // eventParamForWordpressevents: 'event',
  urlForWordpressnews: null, //'https://sustainreport.dk/',
  TitleForWordpressnews: 'Sustain report',
  WordpressnewsFilter: null,
  urlForWordpressnews2: null, //'https://impactinsider.dk',
  TitleForWordpressnews2: 'Impact insider',
  Wordpressnews2Filter: null,
  EnableMultiwordpressFeeds: false,
  TitleForMultiwordpressFeeds: 'News',
  MultiwordpressFeeds: [
    'https://sustainreport.dk',
    'https://impactinsider.dk',
    'https://partnerskaberne.dk',
    'https://danishlifesciencecluster.dk',
  ],
  MultiwordpressFeedsFilter: null,
  urlForWordpresstools: null, // 'https://partnerskaberne.dk',
  TitleForWordpresstools: 'Værktøjer',
  WordpresstoolsFilter: 47,

  // EnablePremiumCommunities: true,

  chatbotScriptUrl:
    // 'https://cdn.jsdelivr.net/gh/agerskov/chatbot1.6/dist/web.js',
    // 'https://cdn.jsdelivr.net/gh/FlowiseAI/FlowiseChatEmbed/dist/web.js',
    // 'https://cdn.jsdelivr.net/npm/flowise-embed@1.6/dist/web.js',
    'https://cdn.jsdelivr.net/npm/flowise-embed/dist/web.js',
  // get chatbotInCornerScript() {
  //   return `
  //   import Chatbot from '${this.chatbotScriptUrl}';
  //     Chatbot.init({
  //       chatflowid: '5f68afd7-57db-4045-b9ee-350de4c7c32b',
  //       apiHost: '${this.chatbotBuilderApiHost}',
  //       theme: {
  //       button: {
  //         backgroundColor: '#00958b',
  //         right: 60,
  //         bottom: 20,
  //         size: 'medium',
  //         iconColor: 'white',
  //         customIconSrc:
  //           'https://firebasestorage.googleapis.com/v0/b/academondo-demo.appspot.com/o/00000xxx%2Fchat-bubbles-question-svgrepo-com.svg?alt=media&token=8302efe5-8a2a-4042-8dda-527c74fc06ae',
  //       },
  //       chatWindow: {
  //         welcomeMessage:
  //           'Angiv et tema, indenfor management, og jeg udarbejder en quiz. Skriv A, B, C eller D baseret på det svar, du mener er korrekt. Ellers trykker du bare på nulstil og skriver et nyt emne for at starte forfra.',
  //         backgroundColor: '#ffffff',
  //         height: 700,
  //         width: 400,
  //         poweredByTextColor: '#303235',
  //         poweredByLink: 'https://academondo.com',
  //         poweredByText: 'Academondo',
  //         title: 'AAMS Quiz',
  //         botMessage: {
  //           backgroundColor: '#f7f8ff',
  //           textColor: '#303235',
  //           showAvatar: true,
  //           avatarSrc:
  //             'https://firebasestorage.googleapis.com/v0/b/ai-minds.appspot.com/o/aaaa%2Faams%20(1).png?alt=media&token=d4cf2e37-9c3a-4d0a-b1ae-a04624f15607',
  //         },
  //         userMessage: {
  //           backgroundColor: '#00958b',
  //           textColor: '#ffffff',
  //           showAvatar: true,
  //           avatarSrc:
  //             'https://raw.githubusercontent.com/zahidkhawaja/langchain-chat-nextjs/main/public/usericon.png',
  //         },
  //         textInput: {
  //           placeholder: 'Indtast din besked her...',
  //           backgroundColor: '#ffffff',
  //           textColor: '#303235',
  //           sendButtonColor: '#00958b',
  //         },
  //       },
  //     },
  //     })`;
  // },
  chatbotBuilderApiHost: 'https://academondo-aiminds.hf.space',
  // chatbotBuilderApiHost: 'https://academondo-ai.hf.space',
  // chatbotLangFuseApiHost: 'https://cloud.langfuse.com',
  chatbotLangSmithApiHost: 'https://smith.langchain.com',

  umamiKey: 'd1466187-e773-485a-a2a5-5a2f8e8ddd6e',
  umamiShareURL:
    'https://cloud.umami.is/share/An39XiauDnGRko0p/ai.academondo.com',
  // postHogKey: 'phc_i0jtWFvXlRn5eYOWK9I8nfqBWb0vRxYDSozyc4UPlSl',

  //suggestion
  enableCategory0Suggestions: true,
  enableFOISuggestions: true,
  enableTechSuggestions: true,

  enabledGroupPushNotifications: true,
  showNotificationIconWithText: false,

  // cookies
  marketingCookies: false,

  CookieInfoFunctionalText: ``,
  CookieDisclaimerFunctionalText: ``,
  CookieInfoMarketingText: ``,
  CookieDisclaimerMarketingText: ``,

  enableCountdownForEventDeadline: true,

  // matchMyFilter
  SkipInterests: false,
  SkipTechniques: false,
  SkipCat0: false,
  SkipCat1: false,
  SkipCat2: false,
  SkipCat3: false,
  SkipCat4: false,
  SkipCat5: false,
  SkipSiteSubtype: false,
  SkipNetworkSubtype: false,
  ExternalLinkedinFeed: '', // remember to set Id and link in dashboard.ts
  TwitterListHref: false,
  ExternalFeedLeft: false,
  ExternalFeedRight: false,

  SSOEnabled: false,
  LinkedinEnabled: true,
  LinkedinClientId: '86xwgx3pd7jfsp',
  linkedinV2: true,
  enabledSubgroups: true,
  enabledSubgroupsInIdeas: true,
  // combineEventAttendances: true,
  // moveUpcomingGroupsToBottom: true,
  // hideAttending: true,
  // hideMaybe: true,
  groupSideBarExpanded: true,

  onlyCreateIdeasFromSite: false,

  expireSites: false,
  expireProfiles: false,
  expireProfilesWarning: 30, // should be 30 days less than expireProfilesDeadline
  expireProfilesDeadline: 60,
  startingPermissionLevel: AccountPermission.basic,
  priceOnSite: false,
  specialUserAccountTypes: [
    // AccountType.scientist,
    AccountType.labTech,
    // AccountType.medLabTech,
    // AccountType.industry,
    // AccountType.university,
  ],

  enableEventsForUnAuthedUsers: true,
  enableCommunitiesForUnAuthedUsers: true,
  enableIdeasForUnAuthedUsers: true,
  enableSearchForUnAuthedUsers: true,
  enableStartpageForUnAuthedUsers: true,

  TagDescRequired: false,

  // remember to fix dbrules if this should be effective "_publishedCvs" .read= auth !== null should be set to true instead
  enableProfilesForUnAuthedUsers: false,
  enableGroupRolesForCommunity: false,
  enableGroupRolesForEvent: false,
  enableGroupRolesForIdea: true,
  showMemberFilterCategory4: false,
  showMemberFilterCategory5: false,

  showPrintSiteButton: false,
  showPrintableCVButton: false,
  enableEvents: true,
  enableCommunities: true,
  enableChat: true,
  groupChatEnabled: true,
  groupKanbanEnabled: true,
  UseGanttForKanban: true,

  anonymousSearchLog: true,
  canHideIdeaFromSearch: true,
  hideMentorShipOnNewMember: false,
  copyEvent: true,
  copyCommunity: true,
  copyIdea: true,
  showGroupOnGroupMap: false,
  disableMap: false,
  ideaWantedExperience: false,
  ideaImages: 'Images',

  HideAdressForUserProfiles: false,

  jobWantedExperience: false,
  jobImages: 'Images',
  enableJobs: true,
  showJobsInSearchWhenNotLoggedIn: true,
  fillCompanyInfoFromProfileInJobPost: true,
  jobResearchQualificationsAsFilters: false,
  showMiddleName: false,

  allowMultipleItems: true,

  slimSiteIndex: false,
  siteIsUserDriven: true,
  showDepartmentInPersonalDetails: false,
  showSexInPersonalDetails: false,

  showCreateCommunityButtonForUserWithoutPermission: false,
  showCreateEventButtonForUserWithoutPermission: true,
  showCreateIdeaButtonForUserWithoutPermission: false,

  enableMagicLink: false,
  showCVRInputInSiteInfo: false,
  showSiteInfoStep: true,

  enableCoupling: false,
  showApplicationProcessFunctions: false, // leave blank if it should not be shown

  // registerCVRONSites: true,
  // useCategory2AsCategory0: true,

  registerVisitFunctions: '', // leave blank if it should not be shown

  showRelatedJobsFunctions: false, // leave blank if it should not be shown

  showCalendarInNetworks: false, // leave as false if it should not be shown'

  showBorderedButtonsInNavBar: false, // leave as false if it should not be shown
  showCapitalizedButtonsInNavBar: false, // leave as false if it should not be shown

  showAccountChangerInNavBar: true, // leave as false if it should not be shown
  showAccountSelectorIcons: false, // leave as false if it should not be shown
  showChangeAccountTypeInSignup: false, // leave as false if it should not be shown

  enableTagUsersInComments: true, // leave as false if it should not be shown
  enableTagUsersInPosts: true, // leave as false if it should not be shown

  showSiteImageOnMap: true, // leave as false if it should not be shown
  showPlaceImageOnMap: false, // leave as false if it should not be shown
  showNetworkImageOnMap: false, // leave as false if it should not be shown
  showCommunityImageOnMap: false, // leave as false if it should not be shown
  showIdeaImageOnMap: false, // leave as false if it should not be shown
  showCommunityWidgetFirst: false,
  showEventImageOnMap: false, // leave as false if it should not be shown
  showCreatorOfCommunities: true, // leave as false if it should not be shown
  showCreatorOfEvents: true, // leave as false if it should not be shown
  showCreatorOfIdeas: true, // leave as false if it should not be shown
  showOptionToRemoveUsersPostsAndEvEventsOnLeaving: false, // leave as false if it should not be shown
  showOptionToRemoveUsersPostsAndEvEventsOnRemovingUser: false, // leave as false if it should not be shown
  showInviteWidget: true, // leave as false if it should not be shown
  showBasicStep: false, // leave as false if it should not be shown
  RegisterDirectMatch: '', // 'Registrer direkte match', // leave blank if it should not be shown
  contactConsentGiven: '', // 'indkøbsservice', // leave blank if it should not be shown

  // u0Marker1: `
  //     data:image/svg+xml;utf-8, <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="90px" height="90px" viewBox="-260 352 90 90" style="enable-background:new -260 352 90 90;" xml:space="preserve"><style type="text/css"> .st0{fill:%23${colors.reed};} .st1{fill:%23FFFFFF;}</style><g transform="translate(40 -93)"><circle class="st0" cx="-255" cy="490" r="45"/><path class="st1" d='M-245.9,492.1h4.2l-13.5-27.1l-13.6,27.1h4.2l-9.4,16.7h13.5v6.2h10.5v-6.2h13.5L-245.9,492.1z M-265.4,490 l10.2-20.3l10.1,20.3H-265.4z M-252.1,512.9h-6.2v-4.1h6.2V512.9z M-270.4,506.7l8.2-14.6h14l8.2,14.6H-270.4z'/></g></svg>
  //     `,
  u0Marker: '/assets/icons/dc3545-marker.png',
  siteMarker: '/assets/icons/008bff-marker.png',
  u2Marker: '/assets/icons/008bff-marker.png',
  u3Marker: '/assets/icons/fd7e14-marker.png',
  u4Marker: '/assets/icons/6f42c1-marker.png',
  u5Marker: '/assets/icons/40722c-marker.png',
  gMarker: '/assets/icons/6f42c1-marker.png',
  cMarker: '/assets/icons/007816-marker.png',
  eMarker: '/assets/icons/ffc107-marker.png',
  iMarker: '/assets/icons/6c757d-marker.png',
  nMarker: '/assets/icons/254e58-marker.png',
  p0Marker: '/assets/icons/ffc107-marker.png',
  p1Marker: '/assets/icons/e83e8c-marker.png',
  p2Marker: '/assets/icons/6f42c1-marker.png',
  p3Marker: '/assets/icons/6c757d-marker.png',

  termsText: `<p>CONSENT FORM</p><p>&nbsp;</p><p>CONSENT TO PROCESSING</p><p>By agreeing to be added to our database, you consent to the processing of your personal data as set out below.</p><p>&nbsp;</p><p>Data controller:</p><p>AcadeMondo ApS, company registration no. 37919527, Holbergsvej 22, 8800 Viborg, e-mail: support@academondo.com.</p><p>&nbsp;</p><p>Personal data:</p><p>Only non-sensitive information is processed, such as name, address, e-mail address, phone number, picture, nationality, country as well as other publicly available information. No sensitive information such as information on health, racial or ethnic origin will be processed, unless you choose to provide us with such data.</p><p>Purpose of processing:</p><p>Populating and maintaining a CV database of relevant contacts for use by AcadeMondo ApS, as well as relevant partners, for the purpose of establishing contact between interested parties.</p><p>Processing activities:</p><p>Collection, recording, structuring, storage, use, disclosure to partners, e-mail contact, profiling, erasure and deletion.</p><p>Recipients of the personal data:</p><p>The whole purpose of our services is to establish contact between interested parties. Our partners who subscribe to our database from time to time will thus have receive and have access to your personal in-formation for their own purposes and may by this consent send you e-mails</p><p>&nbsp;</p><p>Withdrawal of consent</p><p>You can - unconditionally - withdraw your consent at any time by sending an e-mail to us (see e-mail above). Withdrawal of your consent will not have any negative impact; however, you may no longer re-ceive e-mails from our partners.</p>`,
  get privacyPolicyText() {
    return `<h2><strong>PRIVACY POLICY</strong></h2><p>Your privacy is very important to us! We will thus take great care to keep the trust you deserve when processing your personal data. Please find below our privacy policy in relation to your personal data.</p><p>&nbsp;</p><p>Data controller:</p><p>AcadeMondo ApS, company registration no. 37919527, Holbergsvej 22, 8800 Viborg, e-mail: support@academondo.com.</p><p>&nbsp;</p><p>Personal data:</p><p>Only non-sensitive information is processed, such as name, e-mail address, phone number, picture, [etc.] as well as other publicly available information. No sensitive information such as information on health, racial or ethnic origin will be processed, unless you choose to provide us with such data.</p><p>&nbsp;</p><p>Purpose of processing:</p><p>Populating and maintaining a CV database of relevant contacts for use by AcadeMondo ApS, as well as relevant partners, for the purpose of establishing contact between relevant parties</p><p>Processing activities:</p><p>Collection, recording, structuring, storage, use, disclosure to partners, profiling, erasure and deletion.</p><p>&nbsp;</p><p>Basis for processing</p><p>The processing activities involve only personal information organized to facilitate easier contact between you and other interested parties. The processing activities are based on a consent from you, cf. art. 6(1)(a) of the General Data Protection Regulation.</p><p>Recipients of the personal data:</p><p>The whole purpose of our services is to establish contact between interested parties. Our partners who subscribe to our database from time to time will thus receive and have access to your personal infor-mation for their own purposes and may send you e-mails.</p><p>&nbsp;</p><p>Further we use data processors to assist us in processing the information under our supervision, incl. hosting providers and other third-party service providers.</p><p>Processing outside of the EU/EEA</p><p>We use service providers and have partners outside of the EU/EEA, primarily in United States of America. That means that the processed information will be transferred and processed outside of the EU/EEA. However, we take great care to ensure that this is only done, if the appropriate safeguards are in place. This includes processing pursuant to the &ldquo;Privacy Shield&rdquo; privacy rules in the USA and through the use of contractual clauses ap-proved by the European Commission. Please refer to the European Commission&rsquo;s webpage.</p><p>&nbsp;</p><p>Origin of the data:</p><p>The personal data, which has not been received directly from you, is all sourced from publicly available sourced, e.g. social media, contact pages and searches performed using search engines.</p><p>&nbsp;</p><p>Storage of the personal data:</p><p>The personal information is stored as long as it is relevant for the purpose of maintaining our database, or until you withdraw your consent for such personal data processed on the basis hereof. We will regular-ly evaluate that the processing is still valid and correct and that the purpose of the processing or the processing itself has not changed. Data requested to be deleted will be remove from public immediately, data from backup servers will be deleted within 180 days</p><p>&nbsp;</p><p>Your rights</p><p>&nbsp;</p><p>It is your personal data. Consequently, you have a number of rights.</p><p>&nbsp;</p><p>You can - unconditionally - withdraw any consent given at any time by sending an e-mail to us (see e-mail above). Withdrawal of your consent will not have any negative impact; however, you may no longer re-ceive e-mails from our partners. Withdrawal of your consent will affect the lawfulness of processing based on consent before its withdrawal. Further, it will not affect any processing performed on any other &ndash; lawful &ndash; basis.</p><p>&nbsp;</p><p>Your rights also include the following:</p><p>&nbsp;</p><p>* You can obtain insight into what personal data we are processing about yourself.</p><p>* You can ask us to correct or delete your personal data as well as object to or limit our processing.</p><p>* You can ask us to provide you with your personal data in a structured, commonly used and machine-readable format and to transmit those data to another controller.</p><p>* You can file a complaint with the Danish Data Protection Agency (Datatilsynet).</p><p>&nbsp;</p><p>For more information, please see www.datatilsynet.dk</p><p>&nbsp;</p><p>If you wish to exercise your rights, please send an e-mail to our e-mail stated above.</p><p>&nbsp;</p><p>&nbsp;</p><p>Thank you again for your trust &ndash; we will do our part to honor it!</p>`;
  },
};
